import { CategoryApiOutput } from 'types/category'
import { getApiRequest } from 'utils/fetch-helper'

export async function getIntegrationCategories(): Promise<
    CategoryApiOutput[]
> {
    let results: CategoryApiOutput[] = []
    try {
        const { content } = await getApiRequest(
            '/v1/categories/by-type?type=INTEGRATION'
        )
        results = content
    } catch (e) {
        console.error(e)
    } finally {
        return results
    }
}